import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deletePlazaDeMercado,
  getPlazasDeMercados,
  patchPlazaDeMercado,
  postPlazaDeMercado,
} from 'api/catalogos/plazasDeMercado';
// eslint-disable-next-line react/prop-types
const PlazaDeMercado = ({ permission }) => (
  <PlainCRUD
    title="Zonas de Mercado"
    permission={permission}
    get={getPlazasDeMercados}
    post={postPlazaDeMercado}
    patch={patchPlazaDeMercado}
    delete={deletePlazaDeMercado}
    withoutState
    fields={[defaultFields.descripcion]}
  />
);

export default PlazaDeMercado;
